var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12362 6.12422C3.21698 6.10995 3.31277 6.10254 3.41051 6.10254H16.5867C16.6845 6.10254 16.7802 6.10995 16.8736 6.12422M3.12362 6.12422C2.12694 6.27654 1.40681 7.20989 1.55435 8.2427L2.26864 13.2427C2.4006 14.1664 3.1917 14.8525 4.1248 14.8525H15.8724C16.8055 14.8525 17.5966 14.1664 17.7286 13.2427L18.4429 8.2427C18.5904 7.20989 17.8703 6.27654 16.8736 6.12422M3.12362 6.12422V2.97754C3.12362 1.94201 3.96308 1.10254 4.99862 1.10254H8.23085C8.56237 1.10254 8.88031 1.23424 9.11473 1.46866L10.8825 3.23642C11.1169 3.47084 11.4349 3.60254 11.7664 3.60254H14.9986C16.0341 3.60254 16.8736 4.44201 16.8736 5.47754V6.12422",
    stroke: "#5E5E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.5df75617108ee8bf00625213a8941a70.svg";
export { ForwardRef as ReactComponent };